export const LOGOUT = 'LOGOUT';
export const VT_URL_PARAMS = 'vtUrlParams';
export const TERMS_CONSENT_CHECK = 'terms-consent-check';